import React from 'react';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { SignatureIndex } from '../../../components/atoms/signature/Signature';
import { Box, useMediaQuery } from '@mui/material';
var AdditionalInfoTab = function (props) {
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var isDisabled = props.isDisabled;
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    label: 'Additional info',
                    name: '',
                    md: 9,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'Remark',
                            label: 'Remark',
                            multiline: true,
                            columnSize: 12,
                            minRows: IS_DESKTOP ? 6 : 3,
                            placeholder: 'Additional remarks'
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    label: 'Customer Signature',
                    name: '',
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: 'Signature',
                            label: 'Signature area',
                            columnSize: 12,
                            element: function (_ref) {
                                var value = _ref.value, _a = _ref.name, name = _a === void 0 ? 'Status' : _a;
                                return /*#__PURE__*/ React.createElement(Box, {
                                    border: "1px solid",
                                    borderColor: "secondary.200",
                                    borderRadius: 2,
                                    height: '135px'
                                }, /*#__PURE__*/ React.createElement(SignatureIndex, {
                                    setCanvasImage: '',
                                    canvasImage: '',
                                    isDisabled: isDisabled,
                                    height: 'auto'
                                }));
                            }
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            padding: '20px 24px'
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
    })));
};
export default AdditionalInfoTab;
